export default "__VITE_PUBLIC_ASSET__336d399a__"